import { Table } from '../../Table';
import { TableColumn } from '../../../types/commonTypes';
import { NoDataMessage } from '../../NoDataMessage';

interface props {
  data: any[];
  columns: TableColumn[];
}

export const List = ({ data, columns }: props) => {
  return data.length > 0 ? (
    <Table
      data={data}
      columns={columns}
      csvName="dashboard-card"
      disableToolbar
      dynamicHeight
      height="100%"
    />
  ) : (
    <NoDataMessage subTitle="Try Again Later" />
  );
};
